import { RecursivePartial } from '../../../../types';
import { api } from '../../../api';
import { ApiResponse } from '../../Utilities';
import { ProfileType, ProfileViewModel } from '../../ViewModels';

export class ProfileApi {
    private route = '/Profile';

    getProfileSearch(params: { profileType: ProfileType; companyId?: number }): ApiResponse<ProfileViewModel[]> {
        return api().get(`${this.route}/Search`, { params });
    }

    getProfile(id: number, params: { profileType: ProfileType }): ApiResponse<ProfileViewModel[]> {
        return api().get(`${this.route}/${id}`, { params });
    }

    putProfile(id: number, body: RecursivePartial<ProfileViewModel> | FormData): ApiResponse<ProfileViewModel> {
        return api().put(`${this.route}/${id}`, body);
    }
}
